module.exports = __webpack_public_path__ + "img/GALLERY-CIAZ-3.56609deb.jpg";